import { memo } from 'react'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'

import './carousel-navigation-button.scss'

type Props = {
  onClick: () => void
  side: 'previous' | 'next'
}

const CarouselNavigationButton = ({ onClick, side }: Props) => {
  const buttonIcon =
    side === 'previous' ? <Icon name="arrow-left-small" /> : <Icon name="arrow-right-small" />

  return (
    <button
      data-testid={`carousel-navigation-button-${side}`}
      aria-label={side}
      className={`carousel-navigation-button ${side}`}
      onClick={onClick}>
      {buttonIcon}
    </button>
  )
}

export default memo(CarouselNavigationButton)
